import { render, staticRenderFns } from "./SiteManagement.vue?vue&type=template&id=bd49ffc0&scoped=true"
import script from "./SiteManagement.vue?vue&type=script&lang=js"
export * from "./SiteManagement.vue?vue&type=script&lang=js"
import style0 from "./SiteManagement.vue?vue&type=style&index=0&id=bd49ffc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd49ffc0",
  null
  
)

export default component.exports